module.exports = __webpack_public_path__ + "media/images/values/resourceful-7c031f9809bba759e21d55133bc84fad.svg";